import styled from 'styled-components';

import { colors } from '../../styles/colors';
import { Button } from '../Button';
import { primaryScrollbar } from '~/styles/scrollbar';

export const PaginationContainer = styled.div`
  height: 40px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 25px;
  margin-bottom: 25px;
  margin-right: 10px;
`;

export const Page = styled.div`
  font-size: 1.0rem;
  font-weight: bolder;
  background-color: ${colors.Grey};
  color: ${colors.White};
  border: 0;
  padding: 10px;
  box-shadow: 0 7px 12px rgba(83, 104, 111, 0.12), 0 11px 15px rgba(85, 97, 115, 0.1);
`;

export const ButtonPage = styled.button`
  cursor: pointer;
  outline: none;
  border: 0;
  padding: 10px;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 7px 12px rgba(83, 104, 111, 0.12), 0 11px 15px rgba(85, 97, 115, 0.1);
  background-color: ${colors.brand.principal};
  color: ${colors.White};
`;

export const ResponsiveTable = styled.div<{ verifyMobile?: boolean, variant?: 'striped' }>`
  ${({ verifyMobile }) => (verifyMobile ? `
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
  }
  ` : ' display: block; ')}

  ${({ variant }) => (variant === 'striped' ? primaryScrollbar : '')}
`;

export const TableContainer = styled.table<{ verifyMobile?: boolean, variant?: 'striped' }>`
  ${({ verifyMobile }) => (verifyMobile ? `
    @media (max-width: 768px) {
      display: block;
      overflow-y: hidden;
      overflow-x: auto;
      width: max-content;
    }
  ` : '')}
  width: 99%;
  box-shadow: rgba(62, 71, 86, 0.2) 0 2px 8px;
  border-collapse: collapse;

  ${({ variant }) => (variant === 'striped' ? `
    box-shadow: none;
    width: 100%;

    & > tbody > tr:nth-child(odd) {
      background-color: ${colors.bg['white-0']};
    }

    & > tbody > tr:nth-child(even) {
      background-color: ${colors.bg['weak-100']};
    }

    @media (max-width: 768px) {
      width: 800px;
    }
  ` : '')}
`;

export const TableHead = styled.thead`
`;

export const HeaderRow = styled.tr`
  height: 40px;
  display: table-row;
`;

export const HeaderCell = styled.th<{ variant?: 'striped' }>`
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  border-bottom: solid 1px ${colors.Grey};
  background-color: ${colors.brand.principal};
  color: ${colors.White};

  [role='checkbox'] {
    border-color: ${colors.White};
  }
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }

  ${({ variant }) => (variant === 'striped' ? `
    font-size:14px;
    font-weight: 600;
  ` : `
    font-size: 0.75rem;
  `)}
`;

export const HeaderCellOrder = styled.th<{ variant?: 'striped' }>`
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  border-bottom: solid 1px ${colors.Grey};
  font-size: 0.75rem;
  background-color: ${colors.brand.principal};
  color: ${colors.White};
  cursor: pointer;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }

  ${({ variant }) => (variant === 'striped' ? `
    font-size:14px;
    font-weight: 600;
  ` : `
    font-size: 0.75rem;
  `)}
`;

export const ChevronTop = styled.span`
  border-style: solid;
  border-width: 0.25em 0.25em 0 0;
  content: '';
  display: inline-block;
  height: 0.45em;
  left: 0.15em;
  position: relative;
  top: 0.15em;
  transform: rotate(-45deg);
  vertical-align: top;
  width: 0.45em;
  margin-left: 10px;
  margin-top: 3px;
`;

export const ChevronBottom = styled.span`
  border-style: solid;
  border-width: 0.25em 0.25em 0 0;
  content: '';
  display: inline-block;
  height: 0.45em;
  left: 0.15em;
  position: relative;
  top: 0;
  transform: rotate(135deg);
  vertical-align: top;
  width: 0.45em;
  margin-left: 10px;
  margin-top: 3px;
`;

export const ChevronLeft = styled.span`
  border-style: solid;
  border-width: 0.25em 0.25em 0 0;
  content: '';
  display: inline-block;
  height: 0.65em;
  position: relative;
  top: 0.15em;
  vertical-align: top;
  width: 0.65em;
  left: 0.25em;
  transform: rotate(-135deg);
`;

export const ChevronRight = styled.span`
  border-style: solid;
  border-width: 0.25em 0.25em 0 0;
  content: '';
  display: inline-block;
  height: 0.65em;
  position: relative;
  top: 0.15em;
  vertical-align: top;
  width: 0.65em;
  left: 0;
  transform: rotate(45deg);
`;

export const TableBody = styled.tbody<{ variant?: 'striped' }>`
  border: 1px solid ${({ variant }) => (variant === 'striped' ? colors.stroke['soft-200'] : colors.Grey)};
  ${({ variant }) => variant === 'striped' && `
    tr:nth-child(even) {
      background-color: ${colors.bg['weak-100']};
    }
  `}
`;

export const Row = styled.tr<{ variant?: 'striped' }>`
  height: 35px;
  &:not(:last-child) {
    border-bottom: 1px solid ${({ variant }) => (variant === 'striped' ? colors.stroke['soft-200'] : colors.Grey)};
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const DataCell = styled.td<{ variant?: 'striped' }>`
  text-align: left;
  color: ${({ variant }) => (variant === 'striped' ? colors.text['main-900'] : colors.DarkGrey)};
  padding: 10px;
  font-size: 0.71rem
`;

export const CheckboxStyle = styled.div`
  height: 40px;
  background-color: ${colors.brand.principal};

  [role='checkbox'] {
    border-color: ${colors.White};
  }

  @media (max-width: 1498px) {
    height: 77px;
  }
  @media (max-width: 1260px) {
    height: 97px;
  }
  @media (max-width: 1224px) {
    height: 117px;
  }
  @media (max-width: 1110px) {
    height: 137px;
  }
  @media (max-width: 996px) {
    height: 157px;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const ActionButton = styled(Button)`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    width: 14px;
    height: 14px;
  }
`;
